<template>
  <input
    v-model.trim="url"
    placeholder="www."
    class="box"
    style="text-align: left; flex-grow: 1;"
    v-validate="'url'"
    inputmode="url"
    name="url"
  />
</template>

<script>
export default {
  name: 'WebsiteLinkForm',
  props: {
    value: { type: Object, required: true },
  },

  data() {
    return {
      url: '',
    };
  },

  watch: {
    url() {
      this.$emit('input', {
        ...this.value,
        url: this.url,
      });
    },
  },
};
</script>
